import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Rushabh Panbude </span>
            from <span className="purple"> Nagpur, India</span> .
            <br />I have completed my Bachelor's degree in <span className="purple"> Computer Applications</span> .
            <br />
            <br />Strong in design and integration with intuitive problem-solving skills.
            Proficient in <span className ="purple">C++, JAVA, PYTHON, JAVASCRIPT </span> and <span className ="purple"> SQL</span> .
            Passionate about implementing and launching new projects.
            Ability to translate business requirements into technical solutions.
            Have hands on experience in <span className ="purple">Android Studio, Spring Boot, Node, React, Django</span> and <span className ="purple">AWS </span> . Looking to contribute as a software engineer with a reputed firm driven by technology.
            <br />
            <br />
          </p>
          
          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Rushabh</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
